<template>
  <v-app class="bg-white">
    <v-main class="auth-pages">
      <v-col cols="12" style="display: flex; justify-content: space-around;margin-top: 10px;">
        <img :height="this.$vuetify.breakpoint.xs ? 200 : 200" class="image-logo2" src="@/assets/img/logo.png">
      </v-col>
      <div class="policy-container container">
        <div class="header-section text-center mb-4">
          <h1>🏠 HomeSyncX™️</h1>
          <p class="contact-info">
            📧 <a href="mailto:support@homesyncx.com">support@homesyncx.com</a> | 🌐 <a href="https://www.homesyncx.com" target="_blank">www.homesyncx.com</a>
          </p>
        </div>

        <h1 class="text-center main-title">HomeSyncX™️ Cookie Policy</h1>
        <p class="last-updated text-center">Effective Date: October 26, 2025</p>

        <section>
          <h2>1. Introduction</h2>
          <p>
            This Cookie Policy explains how HomeSyncX™️, operated by Round Tables LLC, uses cookies and similar technologies on our website and platform. By continuing to use our site, you agree to our use of cookies as described in this policy.
          </p>
        </section>

        <section>
          <h2>2. What Are Cookies?</h2>
          <p>
            Cookies are small text files placed on your computer or device when you visit a website. They help improve your browsing experience by remembering your preferences, login sessions, and tracking how you interact with the site.
          </p>
          <p>Cookies can be:</p>
          <ul>
            <li><strong>Session Cookies</strong> – Temporary files deleted once you close your browser.</li>
            <li><strong>Persistent Cookies</strong> – Remain on your device for a set period or until deleted manually.</li>
          </ul>
        </section>

        <section>
          <h2>3. How We Use Cookies</h2>
          <p>HomeSyncX™️ uses cookies to:</p>
          <ul>
            <li>Authenticate users and maintain secure login sessions.</li>
            <li>Track referral activity and monitor affiliate performance.</li>
            <li>Analyze website performance and improve user experience.</li>
            <li>Store user preferences (language, theme, location).</li>
            <li>Deliver personalized marketing where consent has been granted.</li>
          </ul>
          <p>
            We do not use cookies to store personal financial data, passwords, or sensitive personal information.
          </p>
        </section>

        <section>
          <h2>4. Types of Cookies We Use</h2>
          <div class="table-responsive">
            <table class="cookie-table">
              <thead>
                <tr>
                  <th>Type</th>
                  <th>Purpose</th>
                  <th>Example</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td><strong>Essential Cookies</strong></td>
                  <td>Required for platform login and navigation</td>
                  <td>Session ID, Authentication Tokens</td>
                </tr>
                <tr>
                  <td><strong>Analytics Cookies</strong></td>
                  <td>Collect anonymous data for performance tracking</td>
                  <td>Google Analytics, Pixel Tracking</td>
                </tr>
                <tr>
                  <td><strong>Preference Cookies</strong></td>
                  <td>Remember user choices and preferences</td>
                  <td>Saved language or region</td>
                </tr>
                <tr>
                  <td><strong>Marketing Cookies</strong></td>
                  <td>Used for remarketing and campaign tracking (only with consent)</td>
                  <td>Facebook Ads, Google Ads</td>
                </tr>
              </tbody>
            </table>
          </div>
        </section>

        <section>
          <h2>5. Third-Party Cookies</h2>
          <p>
            Some cookies are placed by trusted third parties that provide services to HomeSyncX™️, such as analytics and advertising. These providers have their own privacy and cookie policies, and HomeSyncX™️ is not responsible for their practices.
          </p>
          <p>Examples include:</p>
          <ul>
            <li>Google Analytics</li>
            <li>Meta (Facebook) Pixel</li>
            <li>HubSpot / Go HighLevel CRM (for form and lead tracking)</li>
          </ul>
        </section>

        <section>
          <h2>6. Managing Your Cookie Preferences</h2>
          <p>
            You can manage, block, or delete cookies at any time by adjusting your browser settings.
          </p>
          <p>Instructions vary depending on your browser:</p>
          <ul>
            <li><strong>Chrome:</strong> Settings → Privacy → Cookies and Site Data</li>
            <li><strong>Safari:</strong> Preferences → Privacy → Manage Website Data</li>
            <li><strong>Firefox:</strong> Options → Privacy & Security → Cookies and Site Data</li>
            <li><strong>Edge:</strong> Settings → Cookies and Site Permissions</li>
          </ul>
          <p>
            <strong>Please note:</strong> disabling cookies may affect certain functionality or prevent parts of the site from operating correctly.
          </p>
        </section>

        <section>
          <h2>7. Consent</h2>
          <p>
            Upon your first visit to our website, a banner will appear asking for your consent to use non-essential cookies.
          </p>
          <p>
            You may withdraw or modify your consent at any time by revisiting the cookie settings link in the footer of our site.
          </p>
        </section>

        <section>
          <h2>8. Updates to This Policy</h2>
          <p>
            HomeSyncX™️ reserves the right to modify or update this Cookie Policy at any time.
          </p>
          <p>
            Changes will take effect immediately upon posting, and the updated effective date will reflect at the top of this page.
          </p>
        </section>

        <section>
          <h2>9. Contact Us</h2>
          <p>If you have questions about our use of cookies or data protection practices, please contact:</p>
          <p>
            📧 <a href="mailto:privacy@homesyncx.com">privacy@homesyncx.com</a><br>
            🏢 HomeSyncX™️
          </p>
        </section>

        <div class="back-link-section text-center mt-8">
          <v-btn color="#0052CC" dark @click="$router.push('/')">
            <i class="material-icons-round mr-2">arrow_back</i>
            Back to Home
          </v-btn>
        </div>
      </div>
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: 'CookiePolicy',
};
</script>

<style scoped>
.policy-container {
  max-width: 900px;
  margin: 0 auto;
  padding: 40px 20px;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  line-height: 1.7;
  color: #333;
}

.header-section {
  margin-bottom: 30px;
  padding: 20px;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-radius: 15px;
}

.header-section h1 {
  font-size: 2.5rem;
  font-weight: 700;
  color: #0052CC;
  margin-bottom: 10px;
}

.contact-info {
  font-size: 1rem;
  color: #666;
  margin-top: 10px;
}

.contact-info a {
  color: #0052CC;
  text-decoration: none;
}

.contact-info a:hover {
  text-decoration: underline;
}

.main-title {
  font-size: 2rem;
  font-weight: 700;
  color: #1a1a2e;
  margin-bottom: 10px;
}

.last-updated {
  font-size: 0.95rem;
  color: #666;
  margin-bottom: 40px;
  font-style: italic;
}

section {
  margin-bottom: 40px;
  padding-bottom: 30px;
  border-bottom: 1px solid #e0e0e0;
}

section:last-of-type {
  border-bottom: none;
}

h2 {
  font-size: 1.8rem;
  font-weight: 700;
  color: #0052CC;
  margin-bottom: 20px;
  margin-top: 0;
}

p {
  margin-bottom: 15px;
  font-size: 1rem;
  color: #444;
}

ul {
  margin: 15px 0;
  padding-left: 30px;
}

li {
  margin-bottom: 10px;
  font-size: 1rem;
  color: #444;
}

a {
  color: #0052CC;
  text-decoration: none;
}

a:hover {
  text-decoration: underline;
}

strong {
  font-weight: 600;
  color: #1a1a2e;
}

.table-responsive {
  overflow-x: auto;
  margin: 20px 0;
}

.cookie-table {
  width: 100%;
  border-collapse: collapse;
  background: white;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  overflow: hidden;
}

.cookie-table thead {
  background: linear-gradient(135deg, #0052CC 0%, #003d99 100%);
  color: white;
}

.cookie-table th {
  padding: 15px;
  text-align: left;
  font-weight: 600;
  font-size: 1rem;
}

.cookie-table td {
  padding: 15px;
  border-bottom: 1px solid #e0e0e0;
  font-size: 0.95rem;
}

.cookie-table tbody tr:last-child td {
  border-bottom: none;
}

.cookie-table tbody tr:hover {
  background: #f8f9fa;
}

.back-link-section {
  margin-top: 40px;
  padding-top: 30px;
  border-top: 2px solid #e0e0e0;
}

@media (max-width: 768px) {
  .policy-container {
    padding: 20px 15px;
  }

  .header-section h1 {
    font-size: 1.8rem;
  }

  .main-title {
    font-size: 1.5rem;
  }

  h2 {
    font-size: 1.4rem;
  }

  .cookie-table {
    font-size: 0.85rem;
  }

  .cookie-table th,
  .cookie-table td {
    padding: 10px;
  }
}
</style>

